import ThongTinChung from './ThongTinChung.jsx';
import DanhSachCuocThanhTra from './DanhSachCuocThanhTra.jsx';
import Search from './Search.jsx';
import DialogChinhSuaCuocThanhTra from './DialogChinhSuaCuocThanhTra.jsx';
import NoiDungKienNghi from './NoiDungKienNghi.jsx';
import DoiTuongKienNghiView from './DoiTuongKienNghiView.jsx';
import ToChucLienQuan from './ToChucLienQuan.jsx';

export {
  ThongTinChung,
  DanhSachCuocThanhTra,
  Search,
  DialogChinhSuaCuocThanhTra,
  NoiDungKienNghi,
  DoiTuongKienNghiView,
  ToChucLienQuan
}


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/index.js